// =====================
// ====== Webdeal ======
// =====================
export const CHECKOUT_FETCH_WEBDEALS = "CHECKOUT_FETCH_WEBDEALS";
